module.exports = __webpack_public_path__ + "img/background_player_card.e3012dfb.png";